import PrescriptionsPage from 'components/screens/PrescriptionsPage'

export default function PrescriptionsPageContainer() {
  return <PrescriptionsPage />
}
